/**
 * Ник ссылкой в новой вкладке (доработка M2-1 п. 1): Telegram — t.me,
 * Instagram — instagram.com. Ник хранится без «@», «@» — только на экране.
 */
export function NickLink({ nick, network }: { nick: string | null; network: 'telegram' | 'instagram' }) {
  if (!nick) return <span className="dim">не указан</span>;
  const href = network === 'telegram' ? `https://t.me/${nick}` : `https://instagram.com/${nick}`;
  return (
    <a className="lnk" href={href} target="_blank" rel="noreferrer">
      @{nick}
    </a>
  );
}
